import "./career.css";

const HIGHLIGHTS = [
  { icon: "fa-user-group", label: "Purpose-Driven" },
  { icon: "fa-chart-line", label: "Continuous Growth" },
  { icon: "fa-award", label: "Inclusive Culture" },
];

export default function CareerHero() {
  return (
    <section className="career-hero">
      <div className="career-hero-blob career-hero-blob--l" aria-hidden="true" />
      <div className="career-hero-blob career-hero-blob--r" aria-hidden="true" />
      <div className="career-hero-dots" aria-hidden="true" />

      <div className="career-hero-inner">
        <div className="career-hero-copy">
          <p className="career-eyebrow">CAREERS AT GPS FINVEST</p>
          <h1 className="career-hero-title">
            Build Your Career. Create <span>Real Impact.</span>
          </h1>
          <p className="career-hero-lead">
            At GPS Finvest, we believe great careers are built on purpose,
            growth, and meaningful work. Join a team that&apos;s simplifying
            finance and empowering lives every day.
          </p>

          <div className="career-highlights">
            {HIGHLIGHTS.map((item) => (
              <div key={item.label} className="career-highlight">
                <span className="career-highlight-icon" aria-hidden="true">
                  <i className={`fa-solid ${item.icon}`} />
                </span>
                <span className="career-highlight-label">{item.label}</span>
              </div>
            ))}
          </div>
        </div>

        <div className="career-hero-visual">
          <img
            src="/images/career-hero-handshake.png"
            alt="GPS Finvest team collaborating in the office"
            className="career-hero-img"
          />
        </div>
      </div>
    </section>
  );
}
